"use client";

import { useLocale } from "next-intl";
import React, { type ReactElement } from "react";
import {
  FeatureCard,
  FeatureCardContent,
  FeatureCardDescription,
  FeatureCardLink,
  FeatureCardTitle,
  FeatureCardImage,
} from "@/components";
import { getApplication } from "@/services/applications";
import { Images as Icon } from "lucide-react";

function HomeTeaserGallery(): ReactElement | null {
  const locale = useLocale();
  const application = getApplication("gallery");

  if (!application) return null;

  return (
    <FeatureCard className="relative flex-1 border rounded-xl hover:bg-secondary hover:ring-1">
      <FeatureCardContent className="flex-1 mt-24">
        <FeatureCardTitle className="flex flex-col">
          {application.title[locale]}
        </FeatureCardTitle>
        <FeatureCardDescription className="w-2/3 opacity-80">
          {application.lead[locale]}
        </FeatureCardDescription>
      </FeatureCardContent>
      <FeatureCardImage className="items-start justify-start p-6">
        <Icon size={80} strokeWidth={0.2} />
      </FeatureCardImage>
      <FeatureCardLink href={application.url} />
    </FeatureCard>
  );
}

export { HomeTeaserGallery };
